
$(function($) {
    'use strict';

    $('.gotop').on('click', function (event) {
        event.preventDefault();
        $('html, body').animate({
            scrollTop: 0
        }, 1200, 'easeInOutQuart');
    });

    /**
     * Open external links in another tab (or window)
     */
    $('a[rel*=external]').on('click', function(event) {
        event.preventDefault();
        window.open(this.href);
    });

    $('.gallery-images').magnificPopup({
        type: 'image',
        delegate: 'a',
        closeBtnInside: false,
        gallery: {
            enabled: true
        },
        zoom: {
            enabled: true,
            duration: 300
        }
    });

    $('.go_top a').on('click', function(event) {
        event.preventDefault();
        $('body,html').animate({
            scrollTop: 0
        }, 1800);
        return false;
    });

    $(document)
        .on('mouseenter', '.hoverable > li', function() {
            $(this).addClass("hover");
        })
        .on('mouseleave', '.hoverable > li', function() {
            $(this).removeClass("hover");
        })
        .on('click', '.hoverable > li', function(event) {
            event.preventDefault();
            var $a = $(this).find("a");
            var href = $a.attr('href');
            if (href) {
                // open in same tab (window)
                window.location.href = href;
            }
        });


    $('.home-replacement')
        .on('mouseenter', function() {
            $('.nav-home').addClass('active');
        })
        .on('mouseleave', function() {
            $('.nav-home').removeClass('active');
        });

});

$(window).load(function() {

    /**
     * Stretch the navigation to the full site width

    $('.full-width').horizontalNav({
        tableDisplay: false
    });
    */

    equalheight('.footer-media .inner');
});

$(window).resize(function(){
    equalheight('.footer-media .inner');
});
